import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Link} from "react-router-dom";

import Accordeon from '../../../../../components/Accordeon/accordeon';
import TripProgrammingForm from './TripProgrammingForm';
import TripTruckEntry from './TripTruckEntry';
import TripExit from './TripExit';


class TripClosed extends Component {

    componentDidMount(){
        window.initializeCollapsible();
    }

    render() {
        let {trip} = this.props;
        if(!trip)return <div />;

        return (
            <div>
                <ul className="collapsible no-margin black-collapsible" data-collapsible="expandable">
                    <Accordeon name={'1. Información del viaje'} active bordered>
                        <TripProgrammingForm trip={trip}/>
                    </Accordeon>

                    <Accordeon name={'2. Control de Ingreso'} active bordered>
                        <TripTruckEntry trip={trip} />
                    </Accordeon>

                    <Accordeon name={'3. Control de Salida'} active bordered>
                        <TripExit trip={trip} />
                    </Accordeon>
                </ul>
                <div className={"row center margin-top-20"}>
                    <div className={"col s12"}>
                        <Link to={'/internal-trips'} className={`btn btn-shell-empty z-depth-0 text-center`}>
                            Volver
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};

export default connect(mapStateToProps)(TripClosed);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/InternalTrips/Trip/Done/index.js